// src/router/TermosUso.js

const breadCrumb = [
    {
        label: 'Home',
        to: 'Home'
    },
    {
        label: 'Termo de uso',
        to: 'TermosUso'
    }
]

export default [
    {
        path: '/termo-uso',
        name: 'TermosUso',
        component: () => import('@/views/TermosUso/ListPage.vue'),
        meta: {
            title: 'Termos de Uso',
            breadcrumb: breadCrumb
        },
    },
    {
        path: '/termo-uso/novo',
        name: 'TermoUsoNovo',
        component: () => import('@/views/TermosUso/NovoPage.vue'),
        meta: {
            title: 'Novo Termo de uso',
            breadcrumb: [
                ...breadCrumb,
                {
                    label: 'Novo Termo de  uso',
                    to: 'TermoUsoNovo'
                }
            ]
        }
    },
    {
        path: '/termo-uso/:id/edit',
        name: 'TermoUsoEdit',
        component: () => import('@/views/TermosUso/NovoPage.vue'),
        meta: {
            title: 'Detalhes do Termo Uso',
            breadcrumb: [
                ...breadCrumb,
                {
                    label: 'Detalhes do Termo Uso',
                    to: 'TermoUsoNovo'
                }
            ]
        }
    }

];
